import { FormControl, FormGroup } from '@angular/forms';

export class FormUtils {

    static initFormGroupFromTemplate(template, validators?): FormGroup {
        const keys = Object.keys(template);
        const group = {};
        keys.forEach(key => {
            group[key] = validators && validators[key] ? new FormControl(template[key], validators[key]) : new FormControl(template[key]);
        });
        return new FormGroup(group)
    }

    static disableFormFields(form: FormGroup, list: string[]): void {
        if (form && list && list.length > 0) {
            for (const elem of list) {
                if (form.get(elem)) {
                    form.controls[elem].disable();
                }
            }
        }
    }

    static enableFormFields(form: FormGroup, list: string[]): void {
        if (form && list && list.length > 0) {
            for (const elem of list) {
                if (form.get(elem)) {
                    form.controls[elem].enable();
                }
            }
        }
    }

    static resetOnlyEnabledFormFields(form: FormGroup): void {
        Object.keys(form.controls).forEach(key => {
            if (form.get(key).enabled) {
                form.get(key).reset();
            }
        });
    }

    static patchFormFromObject(obj: any, form: FormGroup, emitEvent: boolean = true): void {
        const keys = Object.keys(obj);
        if (keys && keys.length > 0) {
            keys.forEach(key => {
                const ctrl = form.get(key);
                if (ctrl) {
                    ctrl.setValue(obj[key], { emitEvent });
                }
            })
        }
    }

    static sequencePatchFormFromObject(obj: any, form: FormGroup): void {
        const keys = Object.keys(obj);
        if (keys && keys.length > 0) {
            for (let i = 0; i < keys.length; i++) {
                const ctrl = form.get(keys[i]);
                if (ctrl) {
                    ctrl.setValue(obj[keys[i]]);
                }
            }
        }
    }

}
